<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">紧急求助</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="提交时间">
            <el-date-picker
              v-model="createdate"
              type="date"
              placeholder="选择日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="状态">
            <el-select v-model="status" placeholder="请选择">
              <el-option key label="全部" value></el-option>
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号" prop="phone">
            <el-input v-model="phone"></el-input>
          </el-form-item>
          <el-form-item label="" class="right">
            <el-button @click="onSearch">查 询</el-button>
            <el-button @click="onCancel">清 理</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                type="index"
                label="序号"
                width="80"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="createdate"
                align="center"
                label="提交时间"
              ></el-table-column>
              <el-table-column
                prop="phone"
                label="手机号"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="name"
                label="姓名"
                align="center"
              ></el-table-column>
              <el-table-column
                label="经纬度"
                align="center"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.longitude }},{{ scope.row.latitude }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="address"
                label="地址"
                show-overflow-tooltip
                align="center"
              ></el-table-column>
              <el-table-column
                prop="description"
                align="center"
                label="描述"
                show-overflow-tooltip
              ></el-table-column>
              <el-table-column prop="status" label="状态" align="center">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == '1'">已处理</span>
                  <span v-else>待处理</span>
                </template>
              </el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="160"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="editClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    v-if="scope.row.status != '1'"
                    >处理</el-button
                  >
                  <el-button
                    @click="handleClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                    >详情</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import MyApis from "../../../apis";
import waitAll from "../../../../../../utils/src/waitAll";
import { findAllPage } from "@/api/src/resourceApi";
export default {
  name: "HelpList",
  controller: "UI",
  action: "HelpList",
  data() {
    return {
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      selectData: null,
      phone: "",
      status: "",
      createdate: "",
      statusOptions: [
        { value: 0, label: "待处理" },
        { value: 1, label: "已处理" },
      ],
    };
  },
  created: function () {},
  mounted: function () {
    this.search();
  },
  methods: {
    // 弹出一个错误消息
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    // 表格的选中 可以获得当前选中的数据
    selectionChange(val) {
      // 将选中的数据存储起来
      this.selectData = val;
    },
    search() {
      let form = new URLSearchParams();
      form.append("page", this.currentPage);
      form.append("size", this.pageSize);
      form.append("phone", this.phone);
      form.append("status", this.status === 0 ? "" : this.status);
      form.append("createdate", this.createdate || "");
      findAllPage(form).then((response) => {
        if (this.status === 0) {
          this.tableData = response.data.filter((x) => {
            return x.status != 1;
          });
          this.total = this.tableData.length;
        } else {
          this.tableData = response.data;
          this.total = response.count;
          this.loading = false;
        }
      });
    },
    clearsearch() {
      this.phone = "";
      this.status = "";
      this.createdate = "";
      this.search();
    },

    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
    },
    //编辑按钮
    editClick(index, row) {
      this.$router.push({
        path: "/plugin/seekHelp/UI/HelpInfo",
        query: {
          Id: row.id,
          type: "edit",
        },
      });
    },
    //查看详细
    handleClick(index, row) {
      //console.log(index, row);
      this.$router.push({
        path: "/plugin/seekHelp/UI/HelpInfo",
        query: {
          Id: row.id,
          type: "look",
        },
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/seekHelp/UI/HelpInfo",
        query: {
          type: "add",
        },
      });
    },

    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
